import {
  BankIcon,
  BuildingsIcon,
  CalendarBlankIcon,
  FilesIcon,
  MagnifyingGlassIcon,
  MapTrifoldIcon,
  MegaphoneIcon,
  NewspaperIcon,
  ScalesIcon,
  ToolboxIcon,
  UsersThreeIcon,
  type Icon,
} from '@phosphor-icons/react';

/*
------------------------------------------------------------
Ícones das seções do mega menu
------------------------------------------------------------
O token vem do campo `nav_icon` do conteúdo (behavior `menu_meta`), e não da
URL da seção: renomear ou mover uma pasta não muda mais o ícone. As chaves
espelham o vocabulário `ministerio.publico.federal.menu_icons` do backend —
os dois lados precisam andar juntos.

Token desconhecido (ou seção sem o campo preenchido) cai no ícone padrão: o
menu nunca fica sem ícone.
------------------------------------------------------------
*/
export const MENU_ICONS: Record<string, Icon> = {
  institucional: BankIcon,
  atuacao: ScalesIcon,
  servicos: ToolboxIcon,
  comunicacao: MegaphoneIcon,
  noticias: NewspaperIcon,
  transparencia: MagnifyingGlassIcon,
  cidadao: UsersThreeIcon,
  documentos: FilesIcon,
  eventos: CalendarBlankIcon,
  unidades: MapTrifoldIcon,
};

export const DEFAULT_MENU_ICON: Icon = BuildingsIcon;

export const resolveMenuIcon = (token?: string): Icon =>
  (token && MENU_ICONS[token]) || DEFAULT_MENU_ICON;
